/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EvidenceRecordDeprecatedWarnings
 */
export interface EvidenceRecordDeprecatedWarnings {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedWarnings
     */
    'detectedDpi'?: EvidenceRecordDeprecatedWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedWarnings
     */
    'calculatedDpi'?: EvidenceRecordDeprecatedWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedWarnings
     */
    'colorGradation'?: EvidenceRecordDeprecatedWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedWarnings
     */
    'heightMillis'?: EvidenceRecordDeprecatedWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedWarnings
     */
    'widthMillis'?: EvidenceRecordDeprecatedWarningsWidthMillisEnum;
}

export const EvidenceRecordDeprecatedWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedWarningsDetectedDpiEnum = typeof EvidenceRecordDeprecatedWarningsDetectedDpiEnum[keyof typeof EvidenceRecordDeprecatedWarningsDetectedDpiEnum];
export const EvidenceRecordDeprecatedWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedWarningsCalculatedDpiEnum = typeof EvidenceRecordDeprecatedWarningsCalculatedDpiEnum[keyof typeof EvidenceRecordDeprecatedWarningsCalculatedDpiEnum];
export const EvidenceRecordDeprecatedWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceRecordDeprecatedWarningsColorGradationEnum = typeof EvidenceRecordDeprecatedWarningsColorGradationEnum[keyof typeof EvidenceRecordDeprecatedWarningsColorGradationEnum];
export const EvidenceRecordDeprecatedWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedWarningsHeightMillisEnum = typeof EvidenceRecordDeprecatedWarningsHeightMillisEnum[keyof typeof EvidenceRecordDeprecatedWarningsHeightMillisEnum];
export const EvidenceRecordDeprecatedWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedWarningsWidthMillisEnum = typeof EvidenceRecordDeprecatedWarningsWidthMillisEnum[keyof typeof EvidenceRecordDeprecatedWarningsWidthMillisEnum];


